module.exports = __webpack_public_path__ + "static/about-insta-6@2x-d4e00c62d28a346b4035982767a0d9fc.jpg";